import React, { useCallback } from 'react';
import { dialogConfirm } from '../../../../../elements/Dialog/dialogs';

import Icon from '../../../../../elements/icons/Icon';
import Link from '../../../../../elements/Link';
import styles from '../EventIcons.module.scss';

const LeaveEvent = props => {
    const {event, i18n} = props;

    const handleLeave = useCallback(async () => {
        if (await dialogConfirm(i18n['label.leave-event-confirm'])) {
            app.api.events.leaveEvent(event.id);
        }
    }, [event, i18n]);

    if (!event.allow_join_from_parent) return null;

    return (
        <Link className={styles.icon} onClick={handleLeave}>
            <Icon src="img/event_exit@3x.png" color={event.settings.secondary_color} />
            <div>{i18n['label.leave-event']}</div>
        </Link>
    );
};

export default LeaveEvent;
